export { DetailedPage as InsightsDetailsScreen } from './containers/DetailedPage'
export { InsightsScreen } from './containers/InsightsScreen'
export { InsightsSettings } from './containers/InsightsSettings'
